import React from "react";
import { Button, CircularProgress, Dialog, FormHelperText, Grid, IconButton, Input, makeStyles, Modal, styled, Typography, withTheme, Button as MaterialButton } from "@material-ui/core";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context";
import FormValidator from "../helpers/formValidator";
import SuccessIcon from "../icons/success";
import CloseIcon from "../icons/close";
import PlainIcon from "../icons/plain";
import { urls } from "../constants";

import Link from "@material-ui/core/Link";
import { productsServices } from "../services";

function UnioButton(props) {
  const { onClick, children, className: classNameProps } = props;
  const classes = useStyles({ ...props })();
  return (
    <MaterialButton onClick={onClick} fullWidth className={`${classes.btn} ${classNameProps}`}>
      {children}
    </MaterialButton>
  );
}

const useStyles = ({ ...props }) =>
  makeStyles((theme) => ({
    btn: {
      backgroundColor: theme.palette.secondary.main,
      color: "#FFF",
      height: 41,
      borderRadius: 20.5,
      fontSize: "1.125rem",
      lineHeight: "1.375rem",
      fontWeight: "bold",
      "&:hover": {
        backgroundColor: theme.palette.secondary.main,
      },
    },
  }));

const StyledInput = styled(withTheme(Input))((props) => {
  return {
    background: "#FFF",
    color: props.select ? `${props.theme.palette.secondary.main}!important` : `${props.theme.palette.primary.main}!important`,
    height: props.multiline ? "unset" : props.profile ? "56px!important" : 43,
    padding: props.multiline ? 18 : props.profile ? "0 13px" : "0 18px",
    boxSizing: props.profile ? "content-box" : "unset",
    fontWeight: !props.profile ? "unset" : "500",
    border: props.select || props.profile ? "unset" : props.error ? "1pt solid red" : "1pt solid #B2B2B2",
    boxShadow: props.select || props.profile ? "0px 4px 10px rgba(198, 198, 198, 0.5)" : "unset",
    borderRadius: props.profile ? 22 : 25,
    fontSize: props.profile ? "1.125rem" : 12,
    [props.theme.breakpoints.down("xs")]: {
      height: props.multiline ? "unset" : props.profile ? "56px!important" : 43,
    },
    "& svg": {
      right: 20,
      color: props.theme.palette.secondary.main,
    },
    "&:hover": {
      border: props.select || props.profile ? "unset" : props.error ? "1pt solid red" : "1pt solid #B2B2B2",
    },
    "&:after": {
      border: 0,
    },
    "&:before": {
      border: 0,
    },
    "&:focus": {
      border: props.select || props.profile ? "unset" : props.error ? "1pt solid red" : "1pt solid #B2B2B2",
    },
    "&:active": {
      border: props.select || props.profile ? "unset" : props.error ? "1pt solid red" : "1pt solid #B2B2B2",
    },
  };
});
const ResendEmailModal = ({ open, onClose, assigment }) => {
  const classes = makeStyles((theme) => ({
    button: {
      backgroundColor: "#FFF",
      fontSize: "1rem",
      height: 37,
      width: "8rem",
      borderRadius: 16,
      color: theme.palette.secondary.main,
      border: `1px solid ${theme.palette.secondary.main}`,
      boxSizing: "border-box",
      "&:hover": {
        backgroundColor: theme.palette.secondary.main,
        color: "#FFF",
      },
    },
    paperModal: {
      position: "relative",
      width: "90%",
      top: "unset",
      bottom: "unset",
      left: "unset",
      right: "unset",
      overflowY: "scroll",
      height: "50%",
      backgroundColor: "#FFF",
      boxShadow: theme.shadows[5],
      borderRadius: "45px",
      padding: "12px",
      outline: "none",
      [theme.breakpoints.up("md")]: {
        width: "40%",
      },
      "&::-webkit-scrollbar": {
        width: "1px",
        height: "8px",
      },
      "&::-webkit-scrollbar-track": {
        boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
        webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(0,0,0,.1)",
        borderRadius: "10px",
      },
    },
  }))();

  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState(assigment.email || "N/A");
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  useEffect(() => {
    setEmail(assigment.email);
    setErrors({});
  }, [open]);

  const validator = new FormValidator([
    {
      field: "email",
      method: "isEmpty",
      validWhen: false,
      message: "Ingrese correo electronico.",
    },
    {
      field: "email",
      method: "isEmail",
      validWhen: true,
      message: "Ingrese un correo electronico valido.",
    },
  ]);
  const onBlur = async (field, value) => {
    let validate = validator.validateField(field, value);
    let aux = { ...errors };
    aux[field] = validate[field];
    setErrors(aux);
  };
  const { authState, signOut } = useContext(AuthContext);
  const onSubmit = async () => {
    const validation = validator.validate({
      email,
    });
    setErrors(validation);
    if (validation.isValid) {
      try {
        setLoading(true);
        const response = await productsServices.reAssignProduct({
          data: {
            email,
            id: assigment._id,
          }
        });

        if (response.status !== 200 && response.response && response.response.error) {
           alert(response.response.error.message);
        } else if (response.status === 401) {
           signOut();
        }

        setSuccessMessage("Correo reenviado exitosamente");
        // setTimeout(() => setSuccessMessage(""), 3000);
      } catch (error) {
        setLoading(false);

        alert("error desconocido");
      } finally {
        setLoading(false);
      }
    }
  };

  if (successMessage) {
    return (
      <Dialog
        open={successMessage}
        onClose={() => {
          setSuccessMessage("");
          onClose();
        }}
        style={{ borderRadius: "8rem" }}
        PaperProps={{
          style: {
            borderRadius: "2rem",
          },
        }}
      >
        <Grid container display="flex" direction="column" alignItems="center" justifty="center" style={{ padding: "2rem 1rem", height: "16rem" }}>
          <Grid item>
            <SuccessIcon />
          </Grid>
          <Grid item style={{ margin: "auto 0" }}>
            <Typography style={{ fontWeight: "bold", fontSize: "1rem" }} align="center" color="primary">
              Correo reenviado exitosamente
            </Typography>
          </Grid>
          <Grid item>
            <UnioButton
              fullWidth
              onClick={() => {
                setSuccessMessage("");
                onClose();
              }}
            >
              ACEPTAR
            </UnioButton>
          </Grid>
        </Grid>
      </Dialog>
    );
  }

  return (
    <>
      <Modal style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", marginTop: "auto" }} open={open} disableBackdropClick>
        <Grid container direction="column" justify="flex-start" alignItems="center" item className={classes.paperModal}>
          <IconButton style={{ position: "absolute", right: "1rem" }} onClick={onClose}>
            <CloseIcon />
          </IconButton>
          <Grid container style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Grid item container justify="center" alignItems="center" style={{ margin: "43px 0 30px 0" }}>
              <PlainIcon />
            </Grid>
            <Grid className={classes.closeSesion} justify="center" direction="column" alignItems="center">
              <StyledInput
                disabled={loading}
                onBlur={() => onBlur("email", email)}
                error={errors.email && errors.email.isInvalid}
                style={{ width: "12rem", marginTop: "auto" }}
                value={email}
                onChange={(e) => e.target.value.length < 32 && setEmail(e.target.value)}
                disableUnderline
              />
              <FormHelperText error={errors.email && errors.email.isInvalid}>{errors.email ? errors.email.message : " "}</FormHelperText>
            </Grid>
            <Grid container display="flex" direction="column" justify="center" alignItems="center" item style={{ margin: "auto 0 4rem 0" }}>
              <Button
                disabled={loading}
                className={classes.button}
                fullWidth
                // onClick={() => setSuccessMessage(" ")}
                onClick={() => onSubmit()}
              >
                {loading ? <CircularProgress color="#2196C0" size={24} /> : "REENVIAR"}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Modal>
    </>
  );
};

export default ResendEmailModal;
